import React from 'react';
import { Box } from '@mui/material';
import type { Curve } from '../../../interfaces/toolData';
import type { WaveFileType } from '../../../lib/parsers/types';
import { CurveChip } from '../CurveChip';

interface CurveInfo {
  name: string;
  unit: string;
  fileType: string;
}

interface CurveGridProps {
  curves: CurveInfo[];
  fileType: string;
  fileId: string;
  draggedCurve: string | null;
  onCurveClick: (curve: CurveInfo, fileType: string) => void;
  onDragStart: (curve: CurveInfo, fileType: string) => void;
  onDragEnd: () => void;
  onCurveSelect?: (curve: Curve, fileType: string) => void;
}

export const CurveGrid: React.FC<CurveGridProps> = ({
  curves,
  fileType,
  fileId,
  draggedCurve,
  onCurveClick,
  onDragStart,
  onDragEnd,
  // onCurveSelect - not used in this implementation
}) => {
  // Simply render curves - no error/empty state handling
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {curves.map((curve) => {
        // Check if this curve is draggable (Survey Data is not draggable)
        const isDraggable = curve.name !== 'Survey Data';
        const curveKey = `${fileId}:${curve.name}`;
        const isBeingDragged = draggedCurve === curveKey;

        // Check if this curve is clickable
        const isClickable = !!onCurveClick;

        return (
          <CurveChip
            key={curveKey}
            curveReference={{
              fileType: fileType as WaveFileType, // Use the file-level fileType passed to CurveGrid
              curveName: curve.name
            }}
            displayName={curve.name}
            unit={curve.unit}
            disabled={!isDraggable}
            isClickable={isClickable}
            isDragged={isBeingDragged}
            onClick={(_curveRef) => onCurveClick(curve, fileType)}
            onDragStart={(_curveRef) => onDragStart(curve, fileType)}
            onDragEnd={onDragEnd}
          />
        );
      })}
    </Box>
  );
}; 